import { render, staticRenderFns } from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=template&id=f5db3c0c&scoped=true&"
import script from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=script&lang=js&"
export * from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=script&lang=js&"
import style0 from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=style&index=0&id=f5db3c0c&prod&scoped=true&lang=scss&"
import style1 from "./SMSTextBoxPlaceholdersMenu.vue?vue&type=style&index=1&id=f5db3c0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5db3c0c",
  null
  
)

export default component.exports